/* A Features menu in the header, on every page. v3.

   WHAT CHANGED FROM v2. Nine pages, not eight: Integrations joined the list and
   sits last, after Compliance. It is a feature page like the rest -
   /pages/integrations, rendered by templates/page.rockkt-integrations.liquid.

   THE THREE LISTS, AND WHICH NINE EACH ONE HOLDS. The header menu (here), the
   footer column (rockkt-footer-sync-v4.js) and the button band at the foot of
   the homepage (rockkt-router-v7.js) each carry their own copy of the feature
   pages, and they do NOT all hold the same nine:

     header + footer   the eight product pages, then Integrations
     homepage band     the eight product pages, then ROI

   That is deliberate, and it is the second time the three have diverged. ROI
   went into the band alone because the band exists to SHORTEN the homepage:
   every button there stands in for a section that used to be on the page, and
   ROI was one of them. Integrations never was. What it has on the homepage is
   the logo strip (rockkt-integrations-v1.js), which links straight to the page,
   so a tenth button would be a second route to the same place - and would break
   the band's three-by-three grid into a row of one.

   If a page ever needs to be in all three, bump all three together.

   WHAT CHANGED FROM v1. Eight pages, not six: Rockkt One and Playbooks joined
   the list, and the panel grew a fourth row.

   Playbooks points at /pages/send-playbooks, not /pages/playbooks: that handle
   belongs to the guides hub, which is content rather than product.

   WHY AT RUN TIME. Two different header snippets are in play -
   rockkt-home-shell-v2 on the section pages, and rockkt-page-head on the
   twenty-odd inner pages - and three hand-built templates carry their own copy
   inside files the Admin API will not replace as text. They all share one shape
   though: header.nav > .nav-cta with the Pricing link first, and #navMobile
   with the Pricing link first. So one script finds that Pricing link and puts
   Features immediately before it, in both places. Same route
   rockkt-ccy-top-v3.js takes for the currency pill, which is why the row reads:
   currency, Features, Pricing, Sign in, Join Rockkt.

   ICONS ARE INLINE, NOT SPRITE REFERENCES. The inner pages' sprite carries five
   symbols, none of the nine this needs, so <use href="#g-gift"> would draw
   nothing there. The paths are the same ones as the homepage sprite, copied in.

   The desktop panel opens on hover and on click (touch laptops), closes on
   mouse-out, outside click and Escape, and announces itself with aria-expanded.
   Under the burger breakpoint .nav-cta is hidden by the page's own CSS and the
   menu goes with it; the mobile group takes over. */
(function () {
  var ICON = {
    click:    '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51z"/><path d="M13 13l6 6"/>',
    list:     '<path d="M8 6h13"/><path d="M8 12h13"/><path d="M8 18h13"/><path d="M3 6h.01"/><path d="M3 12h.01"/><path d="M3 18h.01"/>',
    gift:     '<path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>',
    sparkles: '<path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5 10.2 7.7z"/><path d="M19 14l.6 1.6 1.6.6-1.6.6L19 19l-.6-1.6-1.6-.6 1.6-.6z"/>',
    rocket:   '<path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4z"/>',
    chart:    '<path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/>',
    compass:  '<circle cx="12" cy="12" r="10"/><path d="M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36z"/>',
    shield:   '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>',
    link:     '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>'
  };

  /* Nine. The first eight are the same, in the same order and with the same
     one-liners, as the footer column (rockkt-footer-sync-v4.js) and as the
     first eight buttons of the homepage band (rockkt-router-v7.js). The ninth
     differs by surface - see the note at the top of this file. */
  var PAGES = [
    ['/pages/rockkt-one',     'click',    'Rockkt One',    'Send from any LinkedIn profile, without leaving it'],
    ['/pages/send-playbooks', 'list',     'Playbooks',     'Prewrite the send, fire it in twenty seconds'],
    ['/pages/gift-lab',       'gift',     'Gift Lab',      'Any gift, packed, boxed and posted'],
    ['/pages/design-studio',  'sparkles', 'Design Studio', 'Your brand, down to the box on the desk'],
    ['/pages/flight-deck',    'rocket',   'Flight Deck',   'Personalised landing pages, built in minutes'],
    ['/pages/tracking',       'chart',    'Tracking',      'Every send and every signal, in real time'],
    ['/pages/navigator',      'compass',  'Navigator',     'Prospects, sequences and next steps'],
    ['/pages/compliance',     'shield',   'Compliance',    'Caps, approvals and a full audit trail'],
    ['/pages/integrations',   'link',     'Integrations',  'Prebuilt CRM connections, included on every plan']
  ];

  function svg(name, cls) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON[name] + '</svg>';
  }

  function pricingLink(root) {
    if (!root) return null;
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (/\/pages\/pricing(\/|$|\?)/.test(links[i].getAttribute('href') || '')) return links[i];
    }
    return null;
  }

  function here(href) {
    return location.pathname.replace(/\/$/, '') === href;
  }

  /* ---- desktop ---- */
  function buildDesktop() {
    var head = document.querySelector('header');
    var link = pricingLink(head && head.querySelector('.nav-cta') || head);
    if (!link || !link.parentNode) return;
    var wrap = document.querySelector('.rk-feat');
    /* A panel built by v2 is eight items and has to be replaced, not left
       alone - otherwise a cached page keeps the short menu for ever. Same
       count test the footer column uses. */
    if (wrap && wrap.querySelectorAll('.rk-feat-item').length !== PAGES.length) {
      wrap.parentNode.removeChild(wrap);
      wrap = null;
    }
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'rk-feat';
      wrap.innerHTML =
        '<button type="button" class="nav-link rk-feat-btn" aria-haspopup="true" aria-expanded="false">Features' +
          '<svg class="rk-feat-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
        '</button>' +
        '<div class="rk-feat-menu" role="menu" aria-label="Features">' +
          PAGES.map(function (p) {
            return '<a class="rk-feat-item' + (here(p[0]) ? ' is-here' : '') + '" role="menuitem" href="' + p[0] + '">' +
                     '<span class="rk-feat-ic">' + svg(p[1], 'rk-feat-svg') + '</span>' +
                     '<span class="rk-feat-txt"><b>' + p[2] + '</b><span>' + p[3] + '</span></span>' +
                   '</a>';
          }).join('') +
        '</div>';

      var btn = wrap.querySelector('.rk-feat-btn'), closeT = null;
      function open()  { wrap.classList.add('open');    btn.setAttribute('aria-expanded', 'true');  }
      function close() { wrap.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }
      function isOpen(){ return wrap.classList.contains('open'); }

      btn.addEventListener('click', function (e) { e.preventDefault(); isOpen() ? close() : open(); });
      wrap.addEventListener('mouseenter', function () { if (closeT) clearTimeout(closeT); open(); });
      wrap.addEventListener('mouseleave', function () { closeT = setTimeout(close, 160); });
      wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) close(); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { close(); btn.focus(); } });
    }
    /* Always directly before Pricing. Idempotent: the currency pill inserts
       itself before Pricing too, on its own timer, so this is re-run after it. */
    if (wrap.nextElementSibling !== link || wrap.parentNode !== link.parentNode) {
      link.parentNode.insertBefore(wrap, link);
    }
  }

  /* ---- burger menu ---- */
  function buildMobile() {
    var menu = document.getElementById('navMobile') || document.querySelector('.nav-mobile');
    var link = pricingLink(menu);
    if (!link || !link.parentNode) return;
    var g = menu.querySelector('.rk-feat-mob');
    /* Same replace-if-stale rule as the desktop panel above. */
    if (g && g.querySelectorAll('a').length !== PAGES.length) { g.parentNode.removeChild(g); g = null; }
    if (g) return;
    g = document.createElement('div');
    g.className = 'rk-feat-mob';
    g.innerHTML = '<span class="rk-feat-mob-h">Features</span>' +
      PAGES.map(function (p) {
        return '<a href="' + p[0] + '"' + (here(p[0]) ? ' aria-current="page"' : '') + '>' + svg(p[1], 'rk-feat-mob-svg') + p[2] + '</a>';
      }).join('');
    link.parentNode.insertBefore(g, link);
  }

  function build() { buildDesktop(); buildMobile(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  /* rockkt-ccy-top-v3.js rebuilds the header at load + 500ms; settle after it. */
  window.addEventListener('load', function () { setTimeout(build, 650); });
})();
